import type { BillingInterval, BillingPlan } from 'definitions/billing-plans';
import { BILLING_PLANS } from 'definitions';
import { BILLING_PLAN_CATALOGUE } from 'definitions/billing-plans';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatUnits } from '@/state/billing/billing-format';
import { Field, FIELD_CONTROL, PillTabs } from '../../Dashboard/ConsolePanel';

const INTERVAL_OPTIONS = [
  { label: 'Monthly', value: 'month' },
  { label: 'Yearly', value: 'year' },
] as const;

/** "Grow, 250,000 sessions a month"; Unlimited has no allowance to name. */
export const planOptionLabel = (plan: BillingPlan): string => {
  const details = BILLING_PLAN_CATALOGUE[plan];
  return details.sessionsPerMonth === null
    ? details.name
    : `${details.name}, ${formatUnits(details.sessionsPerMonth)} sessions a month`;
};

type PlanChoiceFieldsProps = {
  plan: BillingPlan;
  interval: BillingInterval;
  onPlanChange: (plan: BillingPlan) => void;
  onIntervalChange: (interval: BillingInterval) => void;
  /** Under the plan: what the label means for this account. */
  hint?: string;
};

/**
 * A plan and its interval for an account Polar does not bill: a select, not the sign-up's
 * price cards, because nothing here is bought. The interval is a label too (the allowance
 * window is monthly from the plan's start whatever it says), kept for the record.
 */
export const PlanChoiceFields = ({ plan, interval, onPlanChange, onIntervalChange, hint }: PlanChoiceFieldsProps) => (
  <div className="grid gap-4">
    <Field label="Plan" htmlFor="admin-plan" hint={hint}>
      <Select value={plan} onValueChange={(value) => onPlanChange(value as BillingPlan)}>
        <SelectTrigger id="admin-plan" className={FIELD_CONTROL}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {BILLING_PLANS.map((option) => (
            <SelectItem key={option} value={option}>
              {planOptionLabel(option)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
    <Field label="Interval">
      <div className="whitespace-nowrap">
        <PillTabs
          options={INTERVAL_OPTIONS}
          value={interval}
          onChange={(value) => onIntervalChange(value === 'month' ? 'month' : 'year')}
        />
      </div>
    </Field>
  </div>
);
